import { render, staticRenderFns } from "./equity-comparison.vue?vue&type=template&id=8d866148&scoped=true&lang=pug&"
var script = {}
import style0 from "./equity-comparison.vue?vue&type=style&index=0&id=8d866148&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d866148",
  null
  
)

export default component.exports